import { PageLoader, VerticalContainer } from '@american-autonomy/rantizo-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const PageLoaderContainer: FunctionComponent<Props> = ({ testId = TEST_ID }) => (
    <VerticalContainer className={styles.pageLoaderContainer} testId={testId}>
        <PageLoader />
    </VerticalContainer>
);

export default PageLoaderContainer;
